import React from 'react';
import { Box, chakra, Text } from '@chakra-ui/react';
import { useDrop } from 'react-dnd';
import { DragItem, ItemTypes } from '../dnd/types';
import DragBox from '../dnd/DragBox';
import { colors } from '../../../../../../App/ChakraTheme';

interface SlotProps {
  id: string;
  value?: string;
  showCorrect?: boolean;
  answer?: string;
  updateValue: (toKey: string, newValue: string, fromKey: string) => void;
  slot?: string;
}

const Slot: React.FC<SlotProps> = ({
  id,
  value,
  updateValue,
  slot,
  showCorrect,
  answer,
}) => {
  const [{ highlight }, dropRef] = useDrop(
    () => ({
      accept: ItemTypes.DragBox,
      drop: (item: DragItem, monitor) => {
        updateValue(id, item.text, item.id);
      },
      collect: (monitor) => ({
        highlight: monitor.isOver(),
      }),
    }),
    [],
  );

  return (
    <Box
      minW={value ? undefined : '128px'}
      minH={value ? undefined : '32px'}
      w="fit-content"
      border="1px"
      borderRadius="8px"
      borderColor="gray.500"
      color="blue.500"
      background={
        highlight ? colors.applyOpacity(colors.darkblue, 0.35) : 'white'
      }
      display="inline-flex"
      alignSelf="center"
      ref={dropRef}
    >
      {!value && showCorrect && (
        <Text m={'0 !important'} p={'0 !important'}>
          {answer}
        </Text>
      )}
      {value ? (
        <DragBox
          id={slot}
          background={
            highlight ? colors.applyOpacity(colors.darkblue, 0.35) : 'white'
          }
          text={value}
        />
      ) : (
        <chakra.div px={2} py={1}>
          {' '}
        </chakra.div>
      )}
    </Box>
  );
};

export { Slot };
export default Slot;
